import React from 'react';

export default function MiddleDot(props) {
  return '·';
};
